import { render, staticRenderFns } from "./Dictionary.vue?vue&type=template&id=a60b7b3a&scoped=true&"
import script from "./Dictionary.vue?vue&type=script&lang=js&"
export * from "./Dictionary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60b7b3a",
  null
  
)

component.options.__file = "Dictionary.vue"
export default component.exports